/* Adds semantics to third-party widgets without intercepting clicks or changing cart data. */
(() => {
  'use strict';
  const apply = () => {
    document.querySelectorAll('input.gfbVolumeDiscountWidgetOfferDiscountTierRadio').forEach(input => {
      const card = input.closest('.gfbVolumeBundleTemplate_3_TierWrapper');
      if (!card) return;
      const text = card.innerText.replace(/\s+/g, ' ').trim();
      if (text && input.getAttribute('aria-label') !== text) input.setAttribute('aria-label', text);
    });
    document.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(summary => {
      if (summary.querySelector('a[href],button,[tabindex]')) summary.setAttribute('role', 'group');
    });
    document.querySelectorAll('.instafeed-shoppable__track > li[role="status"]').forEach(item => {
      item.setAttribute('role', 'listitem');
      item.setAttribute('aria-live', 'polite');
    });
    document.querySelectorAll('img[width="1"][height="1"]:not([alt])').forEach(pixel => {
      pixel.setAttribute('alt', '');
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; apply(); });
  };
  const start = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

